<template>
  <div class="feedback">
    <transition name="fade" @enter="enterFeedback">
      <feedback-success
        v-if="showableFeedback"
        :message="'ログアウトしました'"
      />
    </transition>
  </div>
</template>
<script>
import FeedbackSuccess from '../../atoms/feedbacks/feedback-success'

export default {
  components: {
    FeedbackSuccess
  },
  props: {
    isSuccessLogout: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      showableFeedback: false
    }
  },
  mounted() {
    this.showableFeedback = this.isSuccessLogout
  },
  methods: {
    enterFeedback() {
      setTimeout(() => {
        this.showableFeedback = false
      }, 3000)
    }
  }
}
</script>
